import React from "react";
import "./Card.css";

function Card({ data }) {
  return (
    <div className="card">
      <div className="card__ImageContainer">
        <img src={data.teachersPhoto} alt="" />
        <div className="card__teachersName">{data.teacherName}</div>
        <div className="class_appName">{data.appName}</div>
      </div>
      <div className="card__description">{data.description}</div>
    </div>
  );
}

export default Card;
